<template>
  <div class="bread">
    <!-- 柱状图表格 -->
    <template v-if="tableData.length>0">
      <div id="columnarChart"
           ref="columnar"
           class="columnarChart"
           :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
    </template>

    <template v-if="tableData.length === 0">
      <div class="nodata">
        <span>
          <img src="https://bigdata.topeti.com/PCRepository/defaultSvg/Intersect.svg" />
          <div>暂无数据</div>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {chartParse, colorData} from './js/color.js';
let chartsModel = "";
// var curInt = null;


export default {
  name: 'scatterCpn',
  props: {
    h: Number,
    //- 分组字段数据
    row: {
      type: Array,
      default: ()=>[]
    },
    //- 汇总字段数据
    summary: {
      type: Array,
      default: ()=>[]
    },
    //- drage组件大小修改后，饼图实时更新
    changeSize: {
      type: Number,
      default: 0
    },
    //- 表格数据
    tableData: {
      type: Array,
      default: ()=>[]
    },
    //- 表id
    id: {
      type: Number,
      default: 0
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean,
      default: ()=>false
    },
    viewShow: {
      type: Boolean,
      default: ()=>false
    },
    selectIndex: {
      type: Number,
      default: ()=>null
    },
    user: {
      type: Array,
      default: () => []
    },
    width: [String, Number],
    isMobile: {
      type: Boolean,
      default: false
    },
    theme: Object,
    column: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      myChart: '',
      nameArray: [],

    }
  },
  mounted() {
    console.log("this.selectIndex==>",this.selectIndex);
    // if(this.selectIndex){
    //     curInt = this.selectIndex;
    // }
    this.$nextTick(()=>{
      this.openFunBread();
    })

  },
  methods: {
    updateFun(){
      console.log("更新");
      if (this.myChart.resize) this.myChart.resize();

    },
    //- 打开图表
    openFunBread(){
      console.log("openFun",this.tableData.length);
      if(this.tableData.length <= 25 && this.tableData.length > 0){
        this.$nextTick(()=>{
          this.initData();
        })

      }

    },
    // series 值动态计算
    getSeries (ars) {
      const series = []
      for (let s = 0; s < this.summary.length; s++) {
        const i = this.summary[s]
        console.log('动态比对', ars, this.tableData)
        const arr = this.tableData.map((its, index) => [ars[index], its[i.title]])
        if (this.theme && this.theme.axes) {
          series.push({
            type: 'scatter',
            symbolSize: 10,
            // 散点图颜色、描边粗细、颜色
            itemStyle: {
              color: this.theme.color[s-1],
              borderWidth: this.theme.borderWidth,
              borderColor: this.theme.borderColor
            },
            // 最大值气泡效果
            markPoint: {
              itemStyle: {
                normal: {
                  label: {
                    color: this.theme.markTextColor
                  }
                }
              },
              data: [{name:"",type:"max"}]
            },
            // 坐标数组
            data: arr
          })
        } else {
          series.push({
              type: 'scatter',
              symbolSize: 10,
              // 散点图颜色、描边粗细、颜色
              itemStyle: {
                color: colorData(s),
              },
              // 最大值气泡效果
              markPoint: {
                data: [{name:"",type:"max"}],
                itemStyle: {
                  normal: {
                    label: '#eeeeee'
                  }
                }
              },
              // 坐标数组
              data: arr
            })
        }
      }
      return series
    },
    //- 创建图表
    initData() {
      const that = this;
      let nameArray = []
      if (this.column && this.column.length > 0) {
        for (const i of this.tableData) {
          if (Array.isArray(i)) {
            for (const s of i) {
              if (s) nameArray.push(s.name)
            }
          }
        }
        nameArray = Array.from(new Set(nameArray))
      } else {
        nameArray = this.tableData.map(val=>{
          return val.name
        })
      }

      chartsModel = "";
      that.$nextTick(()=>{
        // 基于准备好的dom，初始化echarts实例
        let dom = that.$refs.columnar;
        if (!dom) return
        echarts.registerTheme('macarons', macaronsDatas.theme)
        chartsModel = echarts.init(dom,'macarons');
        const config = {
          type: 'scatter',
          symbolSize: 10,
          // 散点图颜色、描边粗细、颜色
          itemStyle: {
            normal: {
              color: '#333',
            }
          },
          // 最大值气泡效果
          markPoint: {
            data: [{name:"",type:"max"}],
            itemStyle: {
              normal: {
                label: '#eeeeee'
              }
            }
          }
        }
        let option = {
          tooltip: {
            trigger: 'axis',
            backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
            textStyle: {
              color: "#333",
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
/*
          legend: {
            show: true,
            type: 'scroll',
            top: '0',
            left: 'right',
            data: nameArray,
            textStyle:{
              color: '#333'
            }
          },
*/
          grid:{
            top: this.column.length > 0 ? 45 : 20,
            bottom: 20,
            left: 20,
            right: 20,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: nameArray,
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            axisLabel: {
              formatter: function(val) {
                return typeof val === 'string' && val ? val.split(/\1{1}/g).join('') : val
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: true,
              lineStyle: {
                color: '#333',
              }
            },
          },
          series: this.column.length > 0 ? chartParse({
            date: this.tableData, column: this.column, summary: this.summary, xAxisData: nameArray, config: config, colorFu: this.theme && this.theme.axes ? this.theme.color : colorData, type: 'scatter'
          }) : this.getSeries(nameArray)
          // series: this.getSeries(nameArray)
        };

        if (this.column.length > 0) {
          option.legend = {}
          // option.tooltip = {}
        }

        if (this.theme && this.theme.axes) {
          const axisIndex = this.theme.axes.findIndex(its => its.type === 'category')
          const axis = this.theme.axes[axisIndex]

          option.color = this.theme.color
          option.xAxis.axisLine = {
            show: axis.axisLineShow,
            lineStyle: {
              color: axis.axisLineColor
            }
          }
          option.yAxis.axisLine = {
            show: axis.axisLineShow,
            lineStyle: {
              color: axis.axisLineColor
            }
          }
          option.xAxis.axisTick = {
            show: axis.axisTickShow,
            lineStyle: {color: axis.axisTickColor}
          }
          option.yAxis.axisTick = {
            show: axis.axisTickShow,
            lineStyle: {color: axis.axisTickColor}
          }

          option.xAxis.axisLabel = {
            show: axis.axisLabelShow,
            color: axis.axisLabelColor
          }
          option.yAxis.axisLabel = {
            show: axis.axisLabelShow,
            color: axis.axisLabelColor
          }

          option.xAxis.splitLine = {
            show: axis.splitLineShow,
            lineStyle: {
              color: axis.splitLineColor,
            }
          }
          option.yAxis.splitLine = {
            show: axis.splitLineShow,
            lineStyle: {
              color: axis.splitLineColor,
            }
          }

          option.grid.top = 45

        }

        console.log('散点图配置', option, nameArray)

        chartsModel.clear();
        // 绘制图表
        chartsModel.setOption(option);
        chartsModel.off("click");
        chartsModel.on("click", (param)=>{
          //- 设置柱状图点击事件
          if(that.isFrontEnd === true){
            return;
          }
          console.log("柱状图点击事件=====>",param);


          that.relevanceFun(param.name,param.value,param.dataIndex);
        });
        that.myChart = chartsModel;
        that.$forceUpdate();
      })
    },
    //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
    relevanceFun(name,val,index){
      if(this.isFrontEnd === true){
        return;
      }
      let rowName = this.row[0].name;
      let summaryName = this.summary[0].name;
      let array = {};
      const nameArr = name ? name.split(/\1{1}/g) : name;
      if (Array.isArray(nameArr)) {
        for (let i = 0; i < this.row.length; i++) {
          array[this.row[i].name] = nameArr[i]
        }
      } else {
        array[rowName] = nameArr;
      }
      array[summaryName] = val;
      let date = {
        id: this.id,
        value: array,
        selectIndex: index
      }
      if (this.user[index]) date.user = this.user[index]
      this.$emit("relevanceFun",date)
    }




  },
  watch: {
    changeSize(val) {
      console.log("w===>",val)
      if(this.tableData.length>0){
        setTimeout(() => {
          this.updateFun();

        }, 1000);

      }

    },
    'tableData':{
      handler (newV) {
        // do something, 可使用this
        console.log(newV)
        if(newV && newV.length>0){
          this.$nextTick(()=>{
            this.$forceUpdate();
            this.openFunBread();
          })
        }

      },
      deep:true

    },
    'selectIndex': {
      handler(newName) {

        console.log("变话了",newName)
        this.$nextTick(()=>{
          this.$forceUpdate();
          this.initData();
        })
      },
      deep:true
    },
    viewShow: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    width: {
      immediate: true,
      handler () {
        this.updateFun()
      }
    },
    theme: {
      immediate: true,
      deep: true,
      handler () {
        console.log('配置更新')
        this.initData();
      }
    },
  }
}
</script>

<style scoped lang="scss">
.bread {
  width: 100%;
  height: 100%;
  position: relative;

}
.nodata {
  width: 100%;
  text-align: center;
  color: #666666;
  //line-height: 244px;
  height: 100%;
  position: relative;
  span{
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-left: -29px;

  }
}
</style>
